export * from "-!../../../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./general.vue?vue&type=template&id=0180b5e7&scoped=true"


//////////////////
// WEBPACK FOOTER
// ./src/components/clients/client/agents/agent/general.vue?vue&type=template&id=0180b5e7&scoped=true
// module id = Sj6+
// module chunks = 0